import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Details from 'components/simulation/types/scpi/Details';
import Overview from 'components/simulation/types/scpi/Overview';
import Products from 'components/simulation/types/scpi/Products';
import RequestApproval from 'components/simulation/types/scpi/RequestApproval';
import ResponseApproval from 'components/simulation/types/scpi/ResponseApproval';
import { SummaryPage } from 'components/simulation/types/scpi/Summary';

const Router = () => (
    <Routes>
        <Route path="/overview" element={<Overview />} />
        <Route path="/products" element={<Products />} />
        <Route path="/simulation" element={<Details />} />
        <Route path="/approval/request" element={<RequestApproval />} />
        <Route path="/approval/:approval" element={<ResponseApproval />} />
        <Route path="/summary" element={<SummaryPage />} />
    </Routes>
);

export default Router;
